// SeatBooking.js
import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../shared/components/Breadcrumbs';
import { SEAT_BOOKING } from '../../../shared/constants/Constants';
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, Modal, Button } from 'react-bootstrap';
import { loadSeatBookingGetDataRequest, loadSeatBookingDataRequest, loadMyBookingGetDataRequest, loadSeatBookingCancelDataRequest } from '../redux/Actions';
import SeatLayout from './SeatLayout';
import { format } from "date-fns";
import DefaultButton from '../../../shared/components/DefaultButton';
import MyReservationsCalendar from './MyReservationCalender';
import layout from "../../../assets/Layout.png";

const SeatBooking = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(new Date()); // Start with Feb 11, 2026
  const [selectedFloor, setSelectedFloor] = useState("1");
  const { avaibleseats, seats: allSeats, loading, mybookings} = useSelector((state) => state.seatBooking);
  const seats = avaibleseats || [];
  const formattedDate = format(selectedDate, "yyyy-MM-dd");
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const employee = JSON.parse(localStorage.getItem("employee"));
  const emp_name = employee ? [employee.first_name, employee.last_name, employee.emp_no].filter(Boolean).join(", ") : ""; 
  // Check if selected date is before today
  const today = new Date();
  const isPastDate = selectedDate.setHours(0,0,0,0) < today.setHours(0,0,0,0);
  const getRoomLabel = (room) => {  if (!room) return ""; return `Flex Room ${room.split("-")[1]}`; };
  const [showCalendar, setShowCalendar] = useState(false); 
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const minDate = new Date(); // February 11, 2026 (month is 0-indexed)
  const maxDate = new Date();

  // Add 10 weekdays (skip weekends)
  let daysAdded = 0;
  let currentDate = new Date(minDate);

  while (daysAdded < 9) {
    currentDate.setDate(currentDate.getDate() + 1);
    const dayOfWeek = currentDate.getDay();
    
    // Only count weekdays (Monday-Friday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysAdded++;
    }
  }

  maxDate.setTime(currentDate.getTime());                             


  // Load all floors/seats on page load
  useEffect(() => {
    dispatch(loadSeatBookingDataRequest());
  }, [dispatch]);

  // Load seats for selected date & floor
  useEffect(() => {
    dispatch(loadSeatBookingGetDataRequest({
      date: formattedDate,
      floor_plan_id: selectedFloor,
    }));
  }, [formattedDate, selectedFloor, dispatch]);


  // Tiles calculation  
  // Get unique seats by seat_id
  const uniqueSeats = seats.reduce((acc, seat) => {
    if (!acc.find(s => s.seat_id === seat.seat_id)) {
      acc.push(seat);
    }
    return acc;
  }, []);

  const total = uniqueSeats.length;
  // A seat is available if ALL its slots are available (no bookings at all)
  const availableCount = uniqueSeats.filter(seat => {
    const seatBookings = seats.filter(s => s.seat_id === seat.seat_id);
    // Check if any booking exists for this seat
    const hasAnyBooking = seatBookings.some(s => s.seat_status === "booked" || s.seat_status === "partially-booked");
    return !hasAnyBooking;
  }).length;
  // A seat is booked if it has at least one booking
  const bookedCount = uniqueSeats.filter(seat => {
    const seatBookings = seats.filter(s => s.seat_id === seat.seat_id);
    const hasAnyBooking = seatBookings.some(s => s.seat_status === "booked" || s.seat_status === "partially-booked");
    return hasAnyBooking;
  }).length;

  const blockedCount = uniqueSeats.filter(s => s.seat_status === "blocked").length;
  
  return (
    <>
      {/* Top: Breadcrumb */}
      <Row className="align-items-center mb-3">
        <Col>
          <Breadcrumbs children={[{ label: SEAT_BOOKING }]} />
        </Col>
      </Row>
          {/* Tiles */}
        <Row className="mb-4">
          <Col md={3} sm={6}>
            <StatTile number={total} text="TOTAL SEATS" color="#28a745" icon="fa-solid fa-couch" />
          </Col>
          <Col md={3} sm={6}>
            <StatTile number={availableCount} text="AVAILABLE" color="#155f82" icon="fa-solid fa-circle" />
          </Col>
          <Col md={3} sm={6}>
            <StatTile number={bookedCount} text="RESERVED" color="#fd7e14" icon="fa-solid fa-bookmark" />
          </Col>
          <Col md={3} sm={6}>
            <LayoutTile 
              image={layout}
              onClick={() => setShowLayoutModal(true)}
            />
          </Col>
        </Row>
        {/* Layout Modal */}
        <Modal show={showLayoutModal} onHide={() => setShowLayoutModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title className="d-flex flex-column">
              <span className="fw-bold">Office Layout</span>              
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <img src={layout} alt="Full Layout" style={{ width: "100%" }} />
          </Modal.Body>
        </Modal>
      {/* My Booking */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <span
            onClick={() => {
              setShowCalendar(true);              
              //dispatch(loadMyBookingGetDataRequest());
            }}
            style={{
              color: "#6366f1",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: 800,
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            <i className="fas fa-user"></i>
            My Reservations
          </span>
        </div>

      {/* Seat Layout */}
        <SeatLayout
          seats={seats}
          selectedDate={formattedDate}
          selectedFloor={selectedFloor}
          disableBooking={isPastDate}
          onDateChange={(newDate) => {
            setSelectedDate(newDate);
          }}
          minDate={minDate}
          maxDate={maxDate}
        />

                                                                                                              
        {/* My Booking Modal */}
        <Modal size="xl" show={showCalendar} onHide={() => setShowCalendar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>My Reservations</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MyReservationsCalendar />
          </Modal.Body>
        </Modal>

    </>
  );
};

export default SeatBooking;

function StatTile({ number, color, onClick, text, icon }) {
  return <Card className="statCard clickable" style={{ borderLeft: `3px solid ${color}` }} onClick={onClick}>
    <Card.Body>
      <div className="d-flex align-items-center">
        <div>
          <p className="mb-0 text-secondary">{text}</p>
          <h4 className="my-1" style={{ color: color }}>{number}</h4>
        </div>
        <div className="widgets-icons-2 rounded-circle text-white ms-auto" style={{ background: `linear-gradient(45deg, ${color}, 80%, #f28f3420), 100%` }}><i className={icon}></i>
        </div>
      </div>
    </Card.Body>
  </Card>
}
function LayoutTile({ image, onClick }) {
  return (
    <Card 
      className="statCard clickable" 
      style={{ 
        cursor: 'pointer', 
        position: 'relative', 
        overflow: 'hidden',
        minHeight: 'auto',
        height: 'auto'
      }} 
      onClick={onClick}
    >
      <Card.Body className="p-0" style={{ minHeight: 'auto', height: 'auto' }}>
        <div style={{ position: 'relative', width: '100%', height: '80px' }}> {/* Fixed height */}
          <img 
            src={image} 
            alt="Office Layout" 
            style={{ 
              width: '100%', 
              height: '100%',
              objectFit: 'cover'
            }} 
          />
          {/* Overlay with search icon */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(99, 102, 241, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.3s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(99, 102, 241, 0.3)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(99, 102, 241, 0.1)'}
          >
            <i className="fa-solid fa-search" style={{ 
              fontSize: '18px',
              color: '#6366f1',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}></i>
          </div>
          {/* Label at bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            color: 'white',
            padding: '3px',
            textAlign: 'center',
            fontWeight: 600,
            fontSize: '11px',
            lineHeight: '1.2'
          }}>
            OFFICE LAYOUT
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}